import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AsyncSelect from 'react-select/async';
import '../shared.css';

const PurchaseEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [confirmRemove, setConfirmRemove] = useState(null);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, roleName, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 4) return [];
        const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);
        if (response.responseCode === '1111') {
            return response.response_data.map(item => ({
                value: item.Id,
                label: item.Code + '-' + item.Name,
            }));
        }
        return [];
    };

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [itemdetails, setItemDetails] = useState([]);

    useEffect(() => {
        fetchData('PurchaseApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData({ ...response.response_data.Purchase, UpdatedBy: userId });
                    setInvoicedeatils(response.response_data.PurchaseDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Purchase Details:', error);
            });
    }, [id]);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}`, token);
                if (response.responseCode === '1111') {
                    setItemDetails(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        fetchItems();
    }, [companyId, branchId, token]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.GRNNumber) {
            setErrorMessage('GRN Number is required!');
            setIsLoading(false);
            return;
        }
        if (!formData.LRNumber) {
            setErrorMessage('LR Number is required!');
            setIsLoading(false);
            return;
        }
        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Purchase: {
                ...formData,
                ModifiedBy: userId,
                BranchId: branchId,
                CompanyId: companyId,
            },
            PurchaseDetails: invoicedeatils
        };

        updateData('PurchaseApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    const removeRecord = (index) => {
        setConfirmRemove(index);
    };

    const confirmRemoveRecord = () => {
        const index = confirmRemove;
        setConfirmRemove(null);
        const updatedRecords = [...invoicedeatils];
        updatedRecords.splice(index, 1);
        setInvoicedeatils(updatedRecords);

        const Quantity = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
        const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const GSTAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.GSTAmount), 0);
        const TotalAmount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
        totalCalculation(Quantity, Amount, GSTAmount, TotalAmount);
    };

    const [modalData, setModalData] = useState({
        SlNo: '0', ItemName: '', ItemId: '', Quantity: '1',
        Rate: '', Amount: '', GSTRate: '', GSTAmount: '', TotalAmount: '',
    });

    const resetModalData = () => setModalData({
        SlNo: '0', ItemName: '', ItemId: '', Quantity: '1',
        Rate: '', Amount: '', GSTRate: '', GSTAmount: '', TotalAmount: '',
    });

    const saveModalData = () => {
        let errors = "";
        if (!modalData.ItemId) errors = "Item is required";
        else if (!modalData.Quantity || isNaN(modalData.Quantity)) errors = "Quantity must be a valid number";

        if (errors) {
            setErrorMessageModel(errors);
            return;
        }

        setErrorMessageModel('');
        const updatedInvoicedetails = [modalData, ...invoicedeatils];
        setInvoicedeatils(updatedInvoicedetails);
        resetModalData();
        setSelectedOption(null);

        const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
        const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
        const GSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.GSTAmount), 0);
        const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
        totalCalculation(Quantity, Amount, GSTAmount, TotalAmount);
    };

    const totalCalculation = (Quantity, Amount, GSTAmount, TotalAmount) => {
        setFormData((prevData) => ({
            ...prevData,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            GSTAmount: GSTAmount,
            TotalAmount: TotalAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };

    const handleModalInputChange = (e) => {
        const { value } = e.target;
        const quantity = parseFloat(value) || 0;
        const rate = parseFloat(modalData.Rate) || 0;
        const gstrate = parseFloat(modalData.GSTRate) || 0;
        const amount = (quantity * rate).toFixed(2);
        const gstAmount = ((amount * gstrate) / 100).toFixed(2);
        const totalAmount = (parseFloat(amount) + parseFloat(gstAmount)).toFixed(2);
        setModalData({ ...modalData, Quantity: quantity, Amount: amount, GSTAmount: gstAmount, TotalAmount: totalAmount });
    };

    const [selectedOption, setSelectedOption] = useState(null);
    const handleInputChange = (newValue) => newValue;

    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);
        const selectedItemDetail = itemdetails.find((item) => item.Id === selectedOption.value);
        if (selectedItemDetail) {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(selectedItemDetail.PurchaseRate) || 0;
            const gstrate = parseFloat(selectedItemDetail.GSTRate) || 0;
            const amount = (quantity * rate).toFixed(2);
            const gstAmount = ((amount * gstrate) / 100).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(gstAmount)).toFixed(2);
            setModalData({
                ...modalData,
                Rate: rate.toFixed(2),
                GSTRate: gstrate.toFixed(2),
                ItemName: selectedOption.label,
                ItemId: selectedOption.value,
                Amount: amount,
                GSTAmount: gstAmount,
                TotalAmount: totalAmount,
            });
        }
    };

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        const d = new Date(dateString);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <Fragment>
            <div className="pg-container">
                {/* ── Header ── */}
                <div className="pg-header">
                    <h5 className="pg-title">Purchase - Edit</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            {roleName === "SuperAdmin" && (
                                <button className="pg-btn pg-btn-primary" onClick={saveModalData}>
                                    <AddIcon /> Add Item
                                </button>
                            )}
                            <button className="pg-btn pg-btn-success" onClick={handleSubmit} disabled={isLoading}>
                                <DoneIcon /> {isLoading ? <CircularProgress size={14} color="inherit" /> : 'Save'}
                            </button>
                            <Link to="/PurchaseIndex" className="pg-btn pg-btn-danger">
                                <CloseIcon /> Cancel
                            </Link>
                        </div>
                    </div>
                </div>

                {errorMessage && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
                {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

                <div className="pg-card">
                    {/* ── Row 1: GRN / LR ── */}
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                value={formatDateForInput(formData.GRNDate)}
                                onChange={handleChange} name="GRNDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GRN Number <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="GRN Number"
                                value={formData.GRNNumber || ''} onChange={handleChange} name="GRNNumber" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Date <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="date"
                                value={formatDateForInput(formData.LRDate)}
                                onChange={handleChange} name="LRDate" readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">LR Number <span className="req">*</span></span>
                            <input className="pg-hcell-input" type="text" placeholder="LR Number"
                                value={formData.LRNumber || ''} onChange={handleChange} name="LRNumber" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 100px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Row 2: Remarks + Totals ── */}
                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input" type="text" placeholder="Enter Remarks"
                                value={formData.Remarks || ''} onChange={handleChange} name="Remarks" />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.Amount || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">GST Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.GSTAmount || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Total Amount</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text"
                                value={formData.TotalAmount || ''} readOnly />
                        </div>
                    </div>

                    {/* ── Add Item Bar (SuperAdmin only) ── */}
                    {roleName === "SuperAdmin" && (
                        <div className="pg-item-bar" style={{ marginTop: 12 }}>
                            {errorMessageModel && <div className="pg-alert pg-alert-error" style={{ width: '100%', marginBottom: 0 }}>{errorMessageModel}</div>}
                            <div className="pg-field" style={{ flex: '3 1 200px' }}>
                                <label className="pg-label">Item Name</label>
                                <div style={{ marginTop: 6 }}>
                                    <AsyncSelect
                                        cacheOptions
                                        loadOptions={fetchOptions}
                                        onInputChange={handleInputChange}
                                        onChange={handleChangeDrop}
                                        value={selectedOption}
                                        placeholder="Type to search items..."
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        styles={{
                                            control: (base) => ({ ...base, minHeight: 31, height: 31, fontSize: 12.5, borderColor: 'rgba(200,212,224,0.7)', borderRadius: 6 }),
                                            valueContainer: (base) => ({ ...base, padding: '0 10px' }),
                                            indicatorsContainer: (base) => ({ ...base, height: 31 }),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="pg-field narrow">
                                <label className="pg-label">Quantity</label>
                                <input className="pg-input text-right" type="text" name="Quantity"
                                    placeholder="Qty" value={modalData.Quantity} onChange={handleModalInputChange} />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6 }}>
                                <button className="pg-btn pg-btn-success" onClick={saveModalData}>
                                    <AddIcon /> Add
                                </button>
                            </div>
                        </div>
                    )}

                    {/* ── Invoice Items Table ── */}
                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Item Name</th>
                                    <th className="right">Quantity</th>
                                    <th className="right">Rate</th>
                                    <th className="right">Amount</th>
                                    <th className="right">GST</th>
                                    <th className="right">Total</th>
                                    {roleName === "SuperAdmin" && <th className="right">Action</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={roleName === "SuperAdmin" ? 8 : 7} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items found.</td></tr>
                                    : invoicedeatils.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{index + 1}</td>
                                            <td style={{ width: '35%' }}>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{item.Rate}</td>
                                            <td className="right">{item.Amount}</td>
                                            <td className="right">{item.GSTAmount}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{item.TotalAmount}</td>
                                            {roleName === "SuperAdmin" && (
                                                <td className="right">
                                                    <IconButton size="small" onClick={() => removeRecord(index)} title="Remove">
                                                        <DeleteIcon style={{ fontSize: 16, color: '#dc2626' }} />
                                                    </IconButton>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>

                {/* ── Confirm Remove Modal ── */}
                {confirmRemove !== null && (
                    <div className="pg-modal-backdrop" onClick={() => setConfirmRemove(null)}>
                        <div className="pg-modal-card" onClick={e => e.stopPropagation()}>
                            <div className="pg-modal-icon-wrap">
                                <WarningAmberIcon className="pg-modal-icon" />
                            </div>
                            <h6 className="pg-modal-title">Remove Item?</h6>
                            <p className="pg-modal-body">This item will be removed from the invoice. This action cannot be undone.</p>
                            <div className="pg-modal-actions">
                                <button className="pg-modal-btn pg-modal-btn-cancel" onClick={() => setConfirmRemove(null)}>
                                    Cancel
                                </button>
                                <button className="pg-modal-btn pg-modal-btn-confirm" onClick={confirmRemoveRecord}>
                                    <DeleteIcon style={{ fontSize: 15 }} /> Yes, Remove
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Fragment>
    );
};

export default PurchaseEdit;
